<form [formGroup]="dateForm" (input)="onInputChange()" class="pt-1">
  <mat-form-field>
    <input
      matInput
      [matDatepicker]="picker"
      formControlName="selectedDate"
      placeholder="{{ 'PICK_A_DATE' | translate }}"
      (dateChange)="onInputChange()"
    />
    <mat-hint class="text-grey text-sm dark:text-borders-dark"
      >DD/MM/YYYY @if (dateHint) { - {{ dateHint | translate }} }</mat-hint
    >
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</form>
